// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"75df532c","134":"9cc7da2c","185":"22cea267","304":"85b81bea","354":"a0d02f58","511":"5f5d8c94","981":"f6475d57"}[chunkId] + ".chunk.css";
};